import React from "react";

import { useAudienceMutations } from "@/hooks";
import ShareDialog from "./ShareDialog";
import { DialogComponentProps } from "@/context";

type ShareAudienceDialogProps = DialogComponentProps<"shareAudience">;

const ShareAudienceDialog: React.FC<ShareAudienceDialogProps> = ({
  audience,
  open,
  onClose,
}) => {
  const { share } = useAudienceMutations(audience);

  return (
    <ShareDialog
      selectedEntity={audience}
      entityType="Audience"
      open={open}
      onClose={onClose}
      onShare={share}
    />
  );
};

export default ShareAudienceDialog;
